<template>
  <BasicModal
    :title="'表示・確認設定'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <ModalSelectMedia @updated='setIcon' />
    <div class="card-body disp-scroll">
      <div class="icon-box" @mouseover="roboIconHover = true" @mouseleave="roboIconHover = false">
        <Tooltip message="アイコンを初期化する">
          <div class="delete-button" @click="deleteIcon()" v-if="roboIconHover===true && !roboSettings.is_confirm && checkAuthority()">×</div>
        </Tooltip>
        <Tooltip message="アイコンを変更する">
          <img class="chatbot-icon" :src="getIconURL(tempRoboIconId)" @click="modalActiveSelectMedia" v-if="!roboSettings.is_confirm">
          <img class="chatbot-icon not-allowed" :src="getIconURL(tempRoboIconId)" v-else>
        </Tooltip>
        <!-- URLコピー用 -->
        <input type="hidden" style="opacity: 0 !important;" id="copy_code_detail_setting" :value="singleURL"/>
        <button class="button is-small is-primary" @click="copySinglePageURL(roboSettings)" :disabled="!roboSettings.is_confirm">
          <span class="mdi mdi-link-variant -right-8px"></span>
          ロボリンク取得
        </button>
      </div>
      <div class="setting-box">
        <p class="left-col">
          <b>ロボ管理名</b>
          <span style="font-size: 12px; color: #666;">
            <br>※「管理画面で表示するロボ名」を「ロボ利用者から見えるロボ名」と異なるものにしたい場合はこちらから変更できます。
          </span>
        </p>
        <div class="right-col">
          <input style="margin-top: 4px; width: 100%;" class="input is-small" maxlength="150" placeholder="ロボ名" v-model="roboSettings.name" :disabled="roboSettings.is_confirm || !checkAuthority()"/>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col">
          <b>ロボ表示名</b>
          <span style="font-size: 12px; color: #666;">
            <br>※「ロボ利用者から見えるロボ名」を「管理画面で表示するロボ名」と異なるものにしたい場合はこちらから変更できます。
          </span>
        </p>
        <div class="right-col">
          <input style="margin-top: 4px; width: 100%;" class="input is-small" maxlength="150" placeholder="ロボ名" v-model="roboSettings.display_name" :disabled="roboSettings.is_confirm || !checkAuthority()"/>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col">
          <b>デフォルト設定</b>
          <span style="font-size: 12px; color: #666;">
            <br>※ホームページ上で１台もロボが設置されていない場合にデフォルトで表示します。
          </span>
        </p>
        <div class="right-col">
          <b-radio v-model="roboSettings.is_default"
              name="default"
              native-value = true
              :disabled="roboSettings.is_confirm">
              設定する
          </b-radio>
          <b-radio v-model="roboSettings.is_default"
              name="default"
              native-value = false
              :disabled="roboSettings.is_confirm">
              設定しない
          </b-radio>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col">
          <b>
            <a href="https://hr-monster.io" target="_blank">
              HRモンスター 求人ページ
            </a>へ<br/>の公開設定
          </b>
        </p>
        <div class="right-col">
          <b-radio v-model="roboSettings.is_recruit"
              name="recruit"
              native-value = true
              :disabled="roboSettings.is_confirm">
              求人媒体 公開
          </b-radio>
          <b-radio v-model="roboSettings.is_recruit"
              name="recruit"
              native-value = false
              :disabled="roboSettings.is_confirm">
              求人媒体 非公開
          </b-radio>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col">
          <b>編集権限</b>
          <span style="font-size: 12px; color: #666;">
            <br>※編集権限があるユーザーとロボ作成者のみ、パーツ確定/解除、ロボのロック/解除ができます。
          </span>
        </p>
        <div class="right-col">
          <div class="member-box disp-scroll">
            <b-checkbox v-for="(us, idx2) in showUsers" :key="`us-${idx2}`" style="margin: 5px;" v-model="roboSettings.editor" :native-value="us.user_hash" :disabled="roboSettings.is_confirm || Boolean(roboSettings.create_by === us.user_hash) || !checkAuthority()">
              {{us.username}}
            </b-checkbox>
          </div>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col"><b>閲覧権限</b></p>
        <div class="right-col">
          <p style="text-align: left;"><b-switch size="is-small" v-model="roboSettings.is_permitted" :disabled="roboSettings.is_confirm || !checkAuthority()"></b-switch>{{roboSettings.is_permitted ? '権限をON' : '権限をOFF'}}</p>
          <div class="member-box disp-scroll">
            <b-checkbox v-for="(us, idx2) in showUsers" :key="`us-${idx2}`" style="margin: 5px;" v-model="permitList" :native-value="us.user_hash" :disabled="roboSettings.is_confirm || !roboSettings.is_permitted || !checkAuthority()">
              {{us.username}}
            </b-checkbox>
          </div>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col"><b>説明</b></p>
        <div class="right-col">
          <textarea style="margin-top: 4px; height: 100px; width: 100%;" class="textarea is-small" maxlength="300" placeholder="説明" v-model="roboSettings.description" :disabled="roboSettings.is_confirm || !checkAuthority()"></textarea>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col"><b>ヘッダー項目</b></p>
        <div class="right-col">
          <b-radio v-model="roboSettings.bot_header_type"
              name="header"
              native-value = 0
              :disabled="roboSettings.is_confirm || !checkAuthority()">
              個別設定なし
          </b-radio>
          <b-radio v-model="roboSettings.bot_header_type"
              name="header"
              native-value = 1
              :disabled="roboSettings.is_confirm || !checkAuthority()">
              応募
          </b-radio>
          <b-radio v-model="roboSettings.bot_header_type"
              name="header"
              native-value = 2
              :disabled="roboSettings.is_confirm || !checkAuthority()">
              お問い合わせ
          </b-radio>
        </div>
      </div>
      <div class="setting-box">
        <div style="display: flex">
          <p v-if="roboSettings.bot_header_type == 1 || roboSettings.bot_header_type == 2" class="left-col"><b>ヘッダー内文章</b></p>
          <div class="right-col">
            <input placeholder="（例）お申し込みはこちら！" v-if="roboSettings.bot_header_type == 1" v-model="roboSettings.header_title" class="input" type="text" maxlength=16>
            <input placeholder="（例）見学はこちら！" v-if="roboSettings.bot_header_type == 2" v-model="roboSettings.header_title" class="input" type="text" maxlength=16>
            <div style="text-align: left; margin-top: 8px; font-size: 12px" v-if="roboSettings.bot_header_type == 1 || roboSettings.bot_header_type == 2">
              <p>表示する文言を変更することができます。（16文字以内）</p>
              <p v-if="roboSettings.bot_header_type == 1">未入力の場合は、「ご応募はこちら！」と表示されます。</p>
              <p v-if="roboSettings.bot_header_type == 2">未入力の場合は、「お問い合わせはこちら！」と表示されます。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="setting-box">
        <p class="left-col"><b>アンケート表示設定</b></p>
        <div class="right-col">
          <b-radio v-model="roboSettings.is_questionnaire"
              name="questionnaire"
              native-value = true
              :disabled="roboSettings.is_confirm">
              表示あり
          </b-radio>
          <b-radio v-model="roboSettings.is_questionnaire"
              name="questionnaire"
              native-value = false
              :disabled="roboSettings.is_confirm">
              表示なし
          </b-radio>
        </div>
      </div>
      <div class="setting-box" v-if="roboSettings.is_template">
        <p class="left-col"><b>テンプレートの説明</b></p>
        <div class="right-col">
          <textarea style="margin-top: 4px; height: 100px; width: 100%;" class="textarea is-small" maxlength="300" placeholder="テンプレートの説明" v-model="roboSettings.tmp_description" :disabled="roboSettings.is_confirm"></textarea>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="updateChatBot(roboSettings)" :disabled="roboSettings.is_confirm">保存する</button>
    </div>
  </BasicModal>
</template>

<script>
import { mapState }     from 'vuex'
import BasicModal       from '@/components/Modals/BasicModal'
import Tooltip          from '@/components/atoms/tooltips/Tooltip'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import controlLogMixin from '@/mixins/controlLogMixin'
import {
  isRoboEditPermission,
} from '@/functions/checkPermission'

export default {
  components: {
    BasicModal,
    Tooltip,
    ModalSelectMedia
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState('chatbot', ['isChangeName']),
    ...mapState('mediapool', ['images']),
    showUsers () {
        // ログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
  data () {
    return {
      singleURL: null,
      roboSettings: {},
      permitList: [],
      roboIconHover: false,
      tempRoboIconId: null
    }
  },
  created () {
    this.roboSettings = JSON.parse(JSON.stringify(this.chatbot))
    this.tempRoboIconId = (this.images.find((item) => item.pk == this.roboSettings.icon_ref) || {}).image_id
    if (this.roboSettings.permit_users) {
      if (this.roboSettings.permit_users.users) {
        this.permitList = this.roboSettings.permit_users.users
      }
    }
  },
  watch: {
    isShowModal () {
      if (this.isShowModal) {
        this.roboSettings = JSON.parse(JSON.stringify(this.chatbot))
        this.tempRoboIconId = (this.images.find((item) => item.pk == this.roboSettings.icon_ref) || {}).image_id
        if (this.roboSettings.permit_users) {
          if (this.roboSettings.permit_users.users) {
            this.permitList = this.roboSettings.permit_users.users
          }
        }
      }
    }
  },
  methods: {
    cancel () {
      if (!this.isChangeName) {
        this.$emit('cancel', false)
      } else {
        // ロボ名変更のとき
        this.$emit('cancel', false)
        this.$store.dispatch('chatbot/setModalChatBotDetail', false)
      }
    },
    async updateChatBot (chatbot) {
      // エラーチェック
      if (!chatbot.name) {
        alert('ロボ名は一文字以上入力してください')
        return
      }
      this.sendControlLogRelatedChatBot('ロボ設定変更', 'ロボの表示・確認設定にて、保存ボタンを押した。', chatbot)
      if (!chatbot.is_permitted) {
        // 閲覧権限OFFの場合はクリアしてからセットする
        this.permitList = []
      }
      chatbot.permit_users = {
        'users': this.permitList
      }
      await this.$store.dispatch('chatbot/setChatBot', chatbot)
      this.$emit('setIcon', this.tempRoboIconId)
      this.cancel()
    },
    setIcon (id) {
      this.tempRoboIconId = id
    },
    deleteIcon () {
      this.tempRoboIconId = null
    },
    modalActiveSelectMedia () {
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    // icon 表示
    getIconURL (icon_id) {
      let image = this.images.find((item) => item.image_id == icon_id)
      if (image) {
        return image.image_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    // ロボリンク取得
    copySinglePageURL (chatbot) {
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + chatbot.group + '/' + chatbot.bot_id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy_code_detail_setting')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    checkAuthority () {
      return isRoboEditPermission(this.roboSettings, this.user)
    }
  },
  destroyed () {
    // isChangeNameを初期化
    this.$store.dispatch('chatbot/setIsChangeName', false)
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  height: 80vh;
  //overflow: auto;
  .setting-box {
    display: flex;
    margin-top: 16px;
    padding: 8px;
    width: 100%;
    .left-col {
      text-align: left;
      vertical-align: middle;
      width: 250px;
    }
    .right-col {
      width: calc(100% - 250px);
      margin-left: 16px;
      text-align: left;
      .member-box {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        margin-top: 8px;
        height: 160px;
        padding: 8px;
        border: solid thin #ccc;
      }
    }
  }
}
.icon-box {
  width: 40%;
  text-align: center;
  margin: 0 auto;
  .delete-button {
    position: absolute;
    top:   -180px;
    right: -5px;
    height: 20px;
    width:  20px;
    border-radius: 50%;
    line-height: 0.95;
    border: solid thin #ccc;
    background: rgb(255, 255, 255);
    cursor: pointer;
  }
  .chatbot-icon {
    width: 180px;
    height: 180px;
    object-fit: cover;
    border-radius: 50%;
    border: solid thin #ccc;
    cursor: pointer;
  }
  .not-allowed{
    cursor: not-allowed;
  }
  button {
    margin-top: 8px;
    margin-bottom: 8px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailChatBotSetting.vue